import React from 'react';
import { PERMISSION } from 'pages/ReturnCondition/utils/constants';

const ReturnCondition = React.lazy(() => import('pages/ReturnCondition/pages/ReturnCondition'));

const ReturnConditionAdd = React.lazy(() => import('pages/ReturnCondition/pages/ReturnConditionAdd'));

const ReturnConditionMasterDataPage = React.lazy(() =>
  import('pages/ReturnCondition/pages/ReturnConditionMasterDataPage'),
);

const ReturnConditionEdit = React.lazy(() => import('pages/ReturnCondition/pages/ReturnConditionEdit'));
const ReturnConditionDetail = React.lazy(() => import('pages/ReturnCondition/pages/ReturnConditionDetail'));

const returnConditionRoute = [
  {
    path: '/return-condition',
    exact: true,
    name: 'Danh sách Điều kiện đổi trả',
    function: PERMISSION.VIEW,
    component: ReturnCondition,
  },
  {
    path: '/return-condition/master-data',
    exact: true,
    name: 'Khai báo master data đổi/trả',
    function: PERMISSION.EDIT,
    component: ReturnConditionMasterDataPage,
  },
  {
    path: '/return-condition/add',
    exact: true,
    name: 'THÊM MỚI ĐIỀU KIỆN ĐỔI TRẢ',
    function: PERMISSION.ADD,
    component: ReturnConditionAdd,
  },
  {
    path: '/return-condition/edit/:id',
    exact: true,
    name: 'Sửa điều kiện đổi/trả',
    function: PERMISSION.EDIT,
    component: ReturnConditionEdit,
  },
  {
    path: '/return-condition/detail/:id',
    exact: true,
    name: 'Xem Chi tiết điều kiện đổi trả',
    function: PERMISSION.VIEW,
    component: ReturnConditionDetail,
  },
];

export default returnConditionRoute;
